import type {Suggestion} from '../../../conversation-types'
import {CounterLabel} from '@primer/react'
import styles from './AutomatedReviewSuggestion.module.css'
import {AutomatedReviewDiffEntry} from './AutomatedReviewDiffEntry'

interface AutomatedReviewCommentSuggestionProps {
  commentId: string
  suggestion: Suggestion
}

export function AutomatedReviewCommentSuggestion({suggestion}: AutomatedReviewCommentSuggestionProps) {
  return (
    <div className={`d-flex flex-column color-fg-default ${styles.suggestion}`}>
      {/* Description */}
      <div className="color-fg-default">{suggestion.description}</div>

      {/* Metadata */}
      {suggestion.diffEntries.length > 0 && (
        <div className="d-flex flex-items-center flex-justify-between text-small color-fg-muted">
          <div className="text-semibold">
            Suggested changeset <CounterLabel scheme="secondary">{suggestion.diffEntries.length}</CounterLabel>
          </div>
          <span> Copilot is powered by AI and may make mistakes. Always verify output.</span>
        </div>
      )}

      {/* Diffs */}
      {suggestion.diffEntries.map(diffEntry => {
        return <AutomatedReviewDiffEntry key={diffEntry.path} diffEntry={diffEntry} />
      })}
    </div>
  )
}

try{ AutomatedReviewCommentSuggestion.displayName ||= 'AutomatedReviewCommentSuggestion' } catch {}